import * as unirest from 'unirest'
import * as axios from 'axios';

// const autozone_serverUrl = 'http://localhost:8080';
const autozone_serverUrl = 'https://autozone-tms.ew.r.appspot.com';

export function registerMe(idToken,payload) {
  // console.log('register request going out...')
  return unirest
  .post(autozone_serverUrl + '/register_user')
  .headers({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control' : 'max-age=0',
    'authentication' : idToken
  })
  .send(payload)
  .then(reply => {
      if (reply.body){
          // console.log('reply :>> ', reply);
          reply.body.statusCode = reply.statusCode;
          reply.body.statusMessage = reply.statusMessage;
          return reply.body;
      } else {
          return reply;
      }
  }); 
}

export function sendCommand(endpoint,gwt,payload = {}) {
  // console.log('send command request going out...')
  return unirest
  .post(autozone_serverUrl + '/' + endpoint)
  .headers({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control' : 'max-age=0',
    'authentication' : gwt
  })
  .send(payload)
  .then(reply => {
    if (reply.body){
        // console.log('reply :>> ', reply);
        reply.body.statusCode = reply.statusCode;
        reply.body.statusMessage = reply.statusMessage;
        return reply.body;
    } else {
        return reply;
    }
  }); 
}

export function sendForm(endpoint,gwt,formData = null) {
  // console.log('send form request going out...')
  return axios
  .post(autozone_serverUrl + '/' + endpoint,formData,{
    headers: {
      'Accept': 'application/json',
      'Cache-Control' : 'max-age=0',
      'authentication' : gwt
    }
  })
  .then(reply => {
    // console.log('reply :>> ', reply);
    if (reply.data){
        // console.log('reply :>> ', reply);
        reply.data.statusCode = reply.status;
        reply.data.statusMessage = reply.statusText;
        return reply.data;
    } else {
        return reply;
    }
  })
  .catch(error => {
    return {Result:"Failed",Message:error}
  }); 
}

export function runCron(gwt) {
  // console.log('register request going out...')
  return unirest
  .get(autozone_serverUrl + '/run_moodle_cron')
  .headers({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control' : 'max-age=0',
    'authentication' : gwt
  })
  .then(reply => {
      if (reply.body){
          // console.log('reply :>> ', reply);
          reply.body.statusCode = reply.statusCode;
          reply.body.statusMessage = reply.statusMessage;
          return reply.body;
      } else {
          return reply;
      }
  }); 
}

export function localServer(){
  // console.log('called auth');
  return autozone_serverUrl.includes('localhost');
}
